import { interestsData } from "../../i18n"

export default [].concat(
  interestsData.management,
  interestsData.skills,
  interestsData.tech
)
